import { Mail, Ban, CheckCircle } from 'lucide-react';
import type { CustomAction } from '@bliks-io/ui';
import type { User } from '@bliks-io/contracts';

/**
 * Status-specific row actions for a member (invite, suspend, unsuspend).
 */
export function getMemberStatusActions(
  member: User,
  handlers: {
    onSendInvitation: (memberId: string) => void;
    onSuspend: (memberId: string) => void;
    onUnsuspend: (memberId: string) => void;
  },
  t: (key: string) => string
) {
  const actions: CustomAction[] = [];

  if (member.status === 'inactive') {
    actions.push({
      label: t('organization.members.sendInvitationAction'),
      icon: <Mail className="w-4 h-4" />,
      onClick: () => handlers.onSendInvitation(member._id)
    });
  } else if (member.status === 'pending') {
    // Pending users can have invitations resent or be suspended
    actions.push({
      label: t('organization.members.resendInvitationAction'),
      icon: <Mail className="w-4 h-4" />,
      onClick: () => handlers.onSendInvitation(member._id)
    });
    actions.push({
      label: t('organization.members.suspendUser'),
      icon: <Ban className="w-4 h-4" />,
      onClick: () => handlers.onSuspend(member._id),
      variant: 'destructive'
    });
  } else if (member.status === 'suspended') {
    actions.push({
      label: t('organization.members.unsuspendUser'),
      icon: <CheckCircle className="w-4 h-4" />,
      onClick: () => handlers.onUnsuspend(member._id)
    });
  } else if (member.status === 'active') {
    actions.push({
      label: t('organization.members.suspendUser'),
      icon: <Ban className="w-4 h-4" />,
      onClick: () => handlers.onSuspend(member._id),
      variant: 'destructive'
    });
  }

  return actions;
}
